@if (block(); as block) {
  <div class="block-anchor-link my-3">
    <nav class="container">
      <main class="d-flex align-items-start block-anchor-link__main flex-column flex-md-row bg-primary-subtle rounded-1 p-3 p-md-4">
        <span class="anchor-link-list__prefix button button--sm fs-body-xs">Snel naar</span>
        <ul class="anchor-link-list position-relative z-2 align-items-start">
          @for (item of blocks(); track item) {
            <li class="anchor-link-list__item">
              <button
                class="button button--light-primary button--sm fs-body-xs"
                (click)="scrollToBlock(debug() ? item.blockType : item.anchor)"
              >
                <span>
                  @if (debug() && item.blockTypeTitle) {
                    {{ item.blockTypeTitle }}
                  } @else {
                    {{ item.anchorTitle || item.anchor }}
                  }
                </span>
              </button>
            </li>
          }
        </ul>
      </main>
    </nav>
  </div>
}
